import { COOKIE_DURATION, cookieOpts } from '@/utils/cookieOptions'
import {
  CART_RESTORE_PARAM,
  cartRestoreRedirectQuery,
} from '@/utils/cartRestore'

export default async function ({ app, route, redirect }) {
  const token = route.query[CART_RESTORE_PARAM]
  if (!token || typeof token !== 'string') return

  let failed = false

  if (!app.$auth?.loggedIn) {
    const response = await app.$axios
      .$post('/v2/cart/restore', { cart: token })
      .catch(() => null)

    if (response?.order_token) {
      app.$nuxtCookies.set(
        'order_token',
        response.order_token,
        cookieOpts(COOKIE_DURATION.MONTH, { secure: true })
      )
    } else {
      failed = true
    }
  }

  return redirect({
    path: route.path,
    query: cartRestoreRedirectQuery(route.query, { failed }),
  })
}
